const cache = new Map();

/**
 * Sets a value in the cache with an optional expiration time.
 * @param {string} key - The cache key.
 * @param {any} value - The value to cache.
 * @param {number} [ttl] - Time-to-live in milliseconds (optional).
 */
export const setCache = (key, value, ttl) => {
  const expiration = ttl ? Date.now() + ttl : null;
  cache.set(key, { value, expiration });
};

/**
 * Gets a value from the cache if it hasn't expired.
 * @param {string} key - The cache key.
 * @returns {any|null} - The cached value or null if expired/not found.
 */
export const getCache = (key) => {
  const cached = cache.get(key);
  if (!cached) return null;

  const { value, expiration } = cached;
  if (expiration && Date.now() > expiration) {
    cache.delete(key); // Remove expired cache
    return null;
  }

  return value;
};

/**
 * Clears a specific key from the cache.
 * @param {string} key - The cache key.
 */
export const clearCache = (key) => {
  cache.delete(key);
};

/**
 * Clears all cache entries.
 */
export const clearAllCache = () => {
  cache.clear();
};
